import { GroupSelector } from "@app/components/GroupSelector";
import { MainContentContainer } from "@app/components/MainContainer";
import { MainHeader } from "@app/components/MainContainer/MainHeader";
import { MainContent } from "@app/components/MainContainer/MainContent";
import { MainTitle } from "@app/components/MainContainer/MainTitle";
import { MainDescription } from "@app/components/MainContainer/MainDescription";
import { PostingToolbar } from "src/components/PostingToolBar";
import {
  LoadingContainer,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@shortsworks/ui";
import { PostingList } from "@app/components/PostingList";
import { useState, useEffect } from "react";

export type TabIds = "posting" | "temporary" | "hidden";

export const Postings = () => {
  const [selectedGroupIds, setSelectedGroupIds] = useState<string[]>([]);
  const [selectedTab, setSelectedTab] = useState<TabIds>("posting");
  const [selectedIds, setSelectedIds] = useState<Map<TabIds, string[]>>();

  // selectedGroup이 변경되면 gruop selector도 다시 렌더링되는 문제 발생
  const handleChangeGroupIds = (groupIds: string[]) => {
    return setSelectedGroupIds(groupIds);
  };
  const handleClickChangeSelectedTab = (value: TabIds) => {
    return setSelectedTab(value);
  };

  // 탭이 변경되면 기존 선택 내역 사라지도록 변경
  // 로딩 중일 때 없다고 표시되는 점 수정 필요
  const handleSelectPostings = (ids: string[]) => {
    setSelectedIds((prev) => {
      return new Map(prev).set(selectedTab, ids);
    });
  };

  useEffect(() => {
    return setSelectedIds(undefined);
  }, [selectedTab]);

  // validate 될 때 마다 순서가 달라지는 듯 보이는 점 확인 필요
  return (
    <MainContentContainer>
      <MainHeader>
        <MainTitle>포스팅 목록</MainTitle>
        <MainDescription>포스팅 목록을 확인할 수 있습니다.</MainDescription>
      </MainHeader>
      <MainContent disableContainerScroll enableScrollInsideContainer>
        <div className="flex flex-col w-full h-full">
          <GroupSelector
            groupIds={selectedGroupIds}
            onChangeGroupIds={handleChangeGroupIds}
            className="w-48 mb-4"
          />
          <Tabs
            className="flex flex-col h-full"
            defaultValue="posting"
            onValueChange={handleClickChangeSelectedTab}
          >
            <div className="flex flex-row items-center gap-2">
              <TabsList className="w-fit">
                <TabsTrigger value="posting">포스팅</TabsTrigger>
                <TabsTrigger value="temporary">임시 저장</TabsTrigger>
                <TabsTrigger value="hidden">숨김</TabsTrigger>
              </TabsList>
              <PostingToolbar
                selectedTab={selectedTab}
                selectedIds={selectedIds}
                onSelectedIds={setSelectedIds}
              />
            </div>
            <TabsContent
              value="posting"
              className="data-[state='active']:flex flex-col h-full overflow-hidden"
            >
              <LoadingContainer>
                <PostingList
                  params={{
                    groupId: selectedGroupIds,
                  }}
                  onSelect={handleSelectPostings}
                  selectedIds={selectedIds?.get("posting")}
                />
              </LoadingContainer>
            </TabsContent>
            <TabsContent
              value="temporary"
              className="data-[state='active']:flex flex-col h-full overflow-hidden"
            >
              <LoadingContainer>
                <PostingList
                  params={{
                    groupId: selectedGroupIds,
                    draft: true,
                  }}
                  onSelect={handleSelectPostings}
                  selectedIds={selectedIds?.get("temporary")}
                />
              </LoadingContainer>
            </TabsContent>
            <TabsContent
              value="hidden"
              className="data-[state='active']:flex flex-col h-full overflow-hidden"
            >
              <LoadingContainer>
                <PostingList
                  params={{
                    groupId: selectedGroupIds,
                    hidden: true,
                  }}
                  onSelect={handleSelectPostings}
                  selectedIds={selectedIds?.get("hidden")}
                />
              </LoadingContainer>
            </TabsContent>
          </Tabs>
        </div>
      </MainContent>
    </MainContentContainer>
  );
};
